import styled from "styled-components";

export const IntroSection = styled.div<{ hasBackground?: boolean }>`
  p {
    margin-top: 0;
    font-weight: 300;
    font-size: 0.938rem;
    line-height: 1.4rem;
  }
  ${(props) => props.theme.media.medium} {
    grid-column: span 6;
  }
  ${(props) => props.theme.media.large} {
    grid-column: span 5;
  }
`;

export const Heading = styled.h2`
  margin: 0px auto 1rem;

  ${(props) => props.theme.media.medium} {
    font-size: 2rem;
  }
`;

export const SubHeading = styled.h3`
  margin: 0;
  color: ${(props) => props.theme.colors.accent1};

  ${(props) => props.theme.media.medium} {
    font-size: 1.5rem;
  }
`;

export const IconKeyRow = styled.div`
  display: flex;
  gap: 0.5rem;

  p {
    font-weight: 500;
    margin-bottom: 0;
  }
`;

export const IconContainer = styled.div`
  padding-top: 2px;
  width: 2rem;
`;

export const IconKey = styled.div`
  background-color: ${(props) => props.theme.colors.lightest};
  padding: 1.5rem 1rem;
  border-radius: 2px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;

  ${IconKeyRow}:last-of-type {
    margin-bottom: 0;
  }
  ${(props) => props.theme.media.medium} {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
  ${(props) => props.theme.media.large} {
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem;
  }
`;

export const StatusLegend = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
`;
